/** Keep the same admission key on uncertain retries, but allocate a new key
 * after a successful delivery so an intentional regeneration remains fresh.
 * Only a digest and random ID are stored, never the campaign input. */
export async function fetchCampaignImage(_url: string, options: RequestInit): Promise<Response> {
  if (typeof options.body !== "string") throw new Error("Campaign image requests require a JSON body");
  const payload = JSON.parse(options.body);
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(options.body));
  const key = `campaign-image-request:${Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("")}`;
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  const response = await fetch("/api/generate-campaign-ad-image", {
    ...options, body: JSON.stringify({ ...payload, renderRequestId: id }),
  });
  if (response.ok) {
    const delivered = await response.clone().json();
    if (typeof delivered.image_url === "string" && delivered.image_url && sessionStorage.getItem(key) === id) {
      sessionStorage.removeItem(key);
    }
  }
  return response;
}
